<template>
  <el-table
    :data="tableData"
    :header-cell-style="headerCellStyle"
    :show-summary="showSummary"
    :summary-method="getSummaries"
    :height="tableHeight"
    :size="tableSize"
    class="table"
    :cell-style="cellStyle"
    @row-click="handleRowClick"
    @selection-change="handleSelectionChange"
  >
    <template v-for="item in titleList">
      <el-table-column
        :key="item.type"
        type="selection"
        width="60"
        :align="item.align ? item.align : 'center'"
        v-if="item.type === 'selection'"
      >
      </el-table-column>
      <el-table-column
        :key="item.type"
        type="index"
        width="60"
        label="序号"
        :align="item.align ? item.align : 'center'"
        v-else-if="item.type === 'index'"
      >
      </el-table-column>
      <!-- 通过回调获取数据 -->
      <el-table-column
        v-else-if="item.type === 'ownCallback'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        :width="item.width"
        :show-overflow-tooltip="item.showOverflowTooltip"
      >
        <template slot-scope="scope">
          <span :style="item.style">
            {{ item.callBack.call($parent, scope.row) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="item.type === 'ownColorText'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        :width="item.width"
        :show-overflow-tooltip="item.showOverflowTooltip"
      >
        <template slot-scope="scope">
          <span :style="item.style">
            {{ item.callBack.call($parent, scope.row, scope.$index) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="item.type === 'ownMultiColorText'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        :width="item.width"
        :show-overflow-tooltip="item.showOverflowTooltip"
      >
        <template slot-scope="scope">
          <template v-for="(txt, index) in item.textArr">
            <span
              v-if="txt[item.prop] === scope.row[item.prop]"
              :key="'$txt' + index"
              :style="txt.style"
            >
              {{ txt.callBack.call($parent, scope.row) }}
            </span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="item.type === 'btnText'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        :width="item.width"
      >
        <template slot-scope="scope">
          <div>
            <template v-for="(ele, i) in item.Arr">
              <template>
                <i
                  :key="'$btn' + i"
                  :style="ele.style"
                  @click="ele.fn.call($parent, scope.row, scope.$index)"
                  >{{ scope.row[ele.prop] }}</i
                >
              </template>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="item.type === 'tableRadio'"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        width="50"
      >
        <template slot-scope="scope">
          <el-radio v-model="scope.row[item.prop]" :label="1"></el-radio>
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="item.type === 'tableSwitch'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
      >
        <template slot-scope="scope">
          <el-switch
            size="small"
            v-model="scope.row[item.prop]"
            :active-color="item.activeColor"
            :inactive-color="item.inactiveColor"
            :active-value="item.activeVal"
            :inactive-value="item.inactiveVal"
            :active-text="item.activeText"
            :inactive-text="item.INactiveText"
          >
          </el-switch>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        v-else-if="item.type === 'oper'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <div>
            <template v-for="(ele, i) in item.btnArr">
              <template>
                <i
                  v-if="ele.show || scope.row[ele.type] === ele.typeVal"
                  :key="'$btn' + i"
                  :style="ele.style"
                  @click="ele.fn.call($parent, scope.row, scope.$index)"
                  >{{ ele.name }}</i
                >
              </template>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="item.type === 'operPro'"
        :label="item.label"
        :align="item.align ? item.align : 'center'"
        :key="item.prop"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <div>
            <template v-for="(ele, i) in item.btnArr">
              <template v-if="ele.type === 'oneState'">
                <i
                  :key="'$btn' + i"
                  :style="ele.style"
                  @click="ele.fn.call($parent, scope.row, scope.$index)"
                  >{{ ele.name }}</i
                >
              </template>
              <template v-else-if="ele.type === 'twoState'">
                <i
                  v-if="scope.row[ele.prop] == ele.val"
                  :key="'$btn' + i"
                  :style="ele.style"
                  @click="ele.fn1.call($parent, scope.row, scope.$index)"
                  >{{ ele.name1 }}</i
                >
                <i
                  v-else
                  :key="'$btn' + i"
                  :style="ele.styledis"
                  @click="ele.fn2.call($parent, scope.row, scope.$index)"
                  >{{ ele.name2 }}</i
                >
              </template>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        align="center"
        :sortable="item.sortable"
        :selection="item.selection"
        :show-overflow-tooltip="item.showOverflowTooltip"
      >
        <template slot-scope="scope">
          <template v-if="scope.row[item.prop]">
            <span>{{ scope.row[item.prop] }}</span>
          </template>
          <template v-else>
            <span>/</span>
          </template>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
  mounted() {},
  name: 'tableDiv',
  props: {
    titleList: Array,
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    headerCellStyle: {
      type: Object,
      default() {
        return { background: '#F4F6FB' };
      },
    },
    showSummary: {
      type: Boolean,
      default() {
        return false;
      },
    },
    getSummaries: {
      type: Function,
    },
    tableHeight: {
      type: String,
    },
    tableSize: {
      type: String,
      default() {
        return 'small';
      },
    },
    cellStyle: {
      type: Object,
      default() {
        return {
          padding: '8px 0',
        };
      },
    },
  },
  data() {
    return {
      multipleSelection: [],
      dataList: [],
    };
  },
  methods: {
    handleRowClick(row, column) {
      this.$emit('handleTableRowClick', row, column);
    },
    handleSelectionChange(selection) {
      this.dataList = selection;
    },
    returnHtml(scope) {
      return this.$parent.returnHtml(scope);
    },

    clickBtn(scope, fn) {
      fn.call(this.$parent, scope);
    },
  },
};
</script>

<style scoped lang="scss">
i {
  font-style: normal;
  display: inline-block;
  cursor: pointer;
  margin: 3px;
  vertical-align: top;
}
.el-table--fit {
  border: 1px solid #ebebeb;
}
</style>



// WEBPACK FOOTER //
// src/components/superTable.vue